import React from 'react';
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SignIcon from 'material-ui/svg-icons/action/check-circle'
import AuthService from "../../../../../services/AuthService";
import Alert from "../../../../shared/utils/Alert";

class Page6 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            remarque: ''
        };
        this.Auth = new AuthService();
        this.handleChange = this.handleChange.bind(this);
        this.onSign = this.onSign.bind(this);
    }

    handleChange(event, value) {
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }

    onSign() {
        const id_salarie = this.props.entretienHeader.id_salarie;
        const id_entretien = this.props.entretienHeader.id;
        const conf = window.confirm('Êtes vous sûr de vouloir signer cet entretien ?\nVous ne pourrez plus le modifier après signature.');
        if (conf) {
            this.Auth.fetch(`/societe/entretien/${id_entretien}/sign`, {
                method: 'put',
                data: {...this.state, id_salarie: id_salarie}
            }).then(x => {
                this.props.history.push('/entreprise/consulter_entretien')
            })
        }
    }

    render() {
        return (
            <div className={'row justify-content-md-center'}>
                <div className='col col-sm-10'>
                    <Alert
                        text="En signant l'entretien vous attestez l'exactitude des informations saisies (ces dernières ne pourront plus être modifiées)."/>
                    <TextField
                        onChange={this.handleChange}
                        value={this.state.remarque}
                        fullWidth={true}
                        multiLine={true}
                        floatingLabelText={'Remarques de fin d\'entretien'}
                        name={'remarque'}
                    />
                    <RaisedButton
                        label={'Finir et signer l\'entretien'}
                        primary={true}
                        fullWidth={true}
                        style={{marginTop: 70}}
                        icon={<SignIcon/>}
                        onClick={this.onSign}
                    />
                </div>

            </div>
        );
    }
}

function mapStateToProps(store) {
    return {entretienHeader: store.entretien.header}
}

export default withRouter(connect(mapStateToProps)(Page6));


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/Page6.js